import { CodingModel, codingOf } from '@lib/guarantees/data-access';

/**
 * How a diagnosis reads in a list it is picked from: the code that identifies it, then the name
 * that says what it is. Shared so a diagnosis offered by the case panel and the same diagnosis
 * offered by a prescription line cannot end up worded differently.
 */
export function diagnosisLabelOf(diagnosis: { icd10?: CodingModel; icpc2?: CodingModel }): string {
  const coding = codingOf(diagnosis);

  return coding?.code ? `${coding.code} — ${coding.name ?? ''}`.trim() : (coding?.name ?? '');
}
